export const RISK_FLAGS = [
  {
    name: 'Contributions',
    link: 'contributions',
    description:
      'The contributions risk actvity evaluates potential compliance risk by identifying HCPs/HCOs that receive unusually frequent, high‑value, or market‑disproportionate contribution payments.',
  },
  {
    name: 'HCP Owned 3rd parties',
    link: 'HCP-owned-3rd-parties',
    description: 'No data',
  },
  {
    name: 'Non-compliance with FMV',
    link: 'Non-compliance-with-FMV',
    description: 'No data',
  },
];
